import React, { useEffect, useState, Fragment, useRef } from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, Divider, FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import ReCAPTCHA from 'react-google-recaptcha';
import { getData, postData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import dayjs from 'dayjs';
import { setPaymentResponse } from '../store/dataslice';
import PayseraPayment from '../PayseraPayment';
import { FaEuroSign } from 'react-icons/fa';
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';
import { animateScroll } from 'react-scroll';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const Bks_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [NumriSerik, setNumriSerik] = useState(null);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [Loan, setLoan] = useState(false);

    // const fetchInstitucioniServiceData = async (token) => {
    //     try {
    //         const response = await getData(`Pagesat/GetKontrolloPagesat?uniref=${NumriSerik}&SherbimiTipiID=15&token=${token}&boxTypeId=2`);
    //         if (response) {
    //             setInstitucioniServiceData(response.data);
    //             setKerkoLoading(false);
    //         }
    //     } catch (error) {
    //         setKerkoLoading(false);
    //         setInstitucioniServiceData(null);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Gabim',
    //             text: "Pagesa me këtë UNIREF nuk është gjetur!",
    //             // confirmButtonText: "Në rregull!"
    //         });
    //     }
    // };

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetKontrolloPagesat', {
                SherbimiTipiID: 15,
                uniref: NumriSerik,
                token: token,
                boxTypeId: 2
            });
            if (response) {
                setInstitucioniServiceData(response.data);
                setKerkoLoading(false);
            }
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Pagesa me këtë UNIREF nuk është gjetur!",
            });
        }
    };

    async function handleSearch() {
        // event.preventDefault();
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };


    const handleBack = () => {
        navigate('/');
    }

    const [shumaValue, setShumaValue] = useState(null);

    const handleShumaChange = (event) => {
        setShumaValue(event.target.value);
    };

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.shuma) {
            setShumaValue(InstitucioniServiceData.shuma);
        }

    }, [InstitucioniServiceData])

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
    });

    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            Email: '',
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values)
        },
    });

    const [handlePayCounter, setHandlePayCounter] = useState(0);

    useEffect(() => {
        if (formik.errors.Email && handlePayCounter === 1) {
            setHandlePayCounter(0);
            const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: `${formik.errors.Email}`
            });

            const emailInput = document.getElementById('email-input');
            if (emailInput) {
                const newPosition = emailInput.offsetTop - 300;

                animateScroll.scrollTo(newPosition, {
                    duration: 500,
                    smooth: true
                });
            }

            const emailInputTx = document.getElementById('email-input-tx');
            if (emailInputTx) {
                emailInputTx.focus();
            }

        }
    }, [formik.errors.Email, handlePayCounter]);

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    }

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                shuma: shumaValue,
                emri: InstitucioniServiceData.emri,
                mbiemri: InstitucioniServiceData.mbiemri,
                institucioniId: InstitucioniServiceData.institucioniId,
                provizioni: 0,
                strProvizioni: '0',
                llojiPagesesID: InstitucioniServiceData.llojiPagesesID,
                numriSerik: NumriSerik,
                NumriUnikPageses: InstitucioniServiceData.numriUnikPageses,
                strDataPageses: `${strDataPageses}`,
                pershkrimi: InstitucioniServiceData.pershkrimi,
                strVlera: `${shumaValue}`,
                strVleraTotale: `${shumaValue}`,
                paymentMethod: 3,
                sherbimiTipiID: 15,
                unirefOK: false,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode
            }
            const response = await postData('Pagesat/PagesaPerSherbime', newData);
            if (response && response.status === 200) {
                // if (!Loan && paymentMethodCode !== 'visa') {
                //     dispatch(setPaymentResponse(response.data.respond));
                //     setPagesaLoading(false);
                // } else {
                //     setLoanLoading(false);
                //     const paymentWindow = window.open('', '_self');
                //     paymentWindow.location.href = `${response.data.link}`;
                // }
                setLoanLoading(false);
                setPagesaLoading(false);
                setUpdateLoader(false);
                const paymentWindow = window.open('', '_self');
                paymentWindow.location.href = `${response.data.link}`;
            }
        } catch (error) {
            setLoanLoading(false);
            setPagesaLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes UNIREF <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="UNIREF"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && NumriSerik !== null) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    {/* <Button className="dynamic-button" type="button" variant="contained" onClick={handleSearch}>
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button> */}

                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || NumriSerik === null || NumriSerik === ''}
                                    // startIcon={kerkoLoading && <CircularProgress size={20} color="inherit" />}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e pagesës</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Emri</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Emri"
                                        disabled
                                        type="text"
                                        value={
                                            InstitucioniServiceData &&
                                                InstitucioniServiceData.emri && InstitucioniServiceData.mbiemri ?
                                                InstitucioniServiceData.emri + ' ' + InstitucioniServiceData.mbiemri : ''
                                        }
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div id="email-input" className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="email-input-tx"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            (formik.touched.Email && formik.errors.Email) &&
                                            (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Kompania e sigurimeve</label>
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Kompania e sigurimeve"
                                        disabled
                                        type="text"
                                        value={InstitucioniServiceData && InstitucioniServiceData.instiucioni}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Shuma për pagesë</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="shuma-input-nr"
                                        type='number'
                                        name='shuma'
                                        placeholder="Shuma për pagesë"
                                        className='number-input'
                                        aria-describedby="outlined-input-helper-text"
                                        value={shumaValue}
                                        endAdornment={<FaEuroSign />}
                                        onChange={handleShumaChange}
                                        inputProps={{
                                            'aria-label': 'input',
                                            // inputMode: 'numeric'
                                        }}
                                    />
                                </div>
                                <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        {/* <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayWithLoan}
                                            // disabled
                                            disabled={loanLoading}
                                            startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                        </Button> */}
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayProcess}
                                            disabled={pagesaLoading}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes UNIREF.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div>
    )
}

export default Bks_PaymentFields